import { useEffect, useState } from 'react'
import { Navbar } from './components/Navbar'
import { Hero } from './components/Hero'
import { Features } from './components/Features'
import { Integrations } from './components/Integrations'
import { HowItWorks } from './components/HowItWorks'
import { BuiltForTeams } from './components/BuiltForTeams'
import { CTA } from './components/CTA'
import { Footer } from './components/Footer'
import { DemoModal } from '../../components/DemoModal'

export function LandingPage() {
  const [showDemoModal, setShowDemoModal] = useState(false)

  useEffect(() => {
    // Smooth-scroll to anchor if URL hash is present
    const hash = window.location.hash
    if (hash) {
      setTimeout(() => {
        const id = hash.replace('#', '')
        const el = document.getElementById(id)
        if (el) {
          const navbarHeight = 80
          const top = el.getBoundingClientRect().top + window.pageYOffset - navbarHeight
          window.scrollTo({ top, behavior: 'smooth' })
        }
      }, 100)
    } else {
      window.scrollTo(0, 0)
    }
  }, [])

  return (
    <div className="min-h-screen bg-zinc-950 font-sans antialiased">
      {/* Skip to content — visible only when keyboard-focused. */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:rounded-md focus:bg-cyan-500 focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-white focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-cyan-300"
      >
        Skip to content
      </a>
      <Navbar />
      <main id="main-content">
        <Hero onScheduleDemo={() => setShowDemoModal(true)} />
        <Features />
        <Integrations />
        <HowItWorks />
        <BuiltForTeams />
        <CTA onScheduleDemo={() => setShowDemoModal(true)} />
      </main>
      <Footer />

      <DemoModal isOpen={showDemoModal} onClose={() => setShowDemoModal(false)} />
    </div>
  )
}
